module.exports = __webpack_public_path__ + "img/avatar1.15239f42.png";